<template>
  <div style="padding: 0px" class="sub-view">
    <div class="table-navigation">
      <!-- list filter -->
      <div class="list-filter">
        <!-- filter cabang -->
        <div style="margin-right: 12px" class="filter-pilihan">
          <div @click="openClosePilihanCabang(true)" class="filter">
            <!-- tipe filter -->
            <p>Cabang :</p>
            <!-- value filter -->
            <span>{{ filterData.cabang ? filterData.cabang : "Semua" }}</span>
            <!-- icon filter -->
            <svg
              width="10"
              height="7"
              viewBox="0 0 10 7"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M0.714294 1.35742L5.00001 5.64314L9.28572 1.35742"
                stroke="#A0A3BD"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>

          <!-- box pilihan filter -->
          <div
            style="margin-top: 2px; display: none"
            ref="boxPilihanCabang"
            class="box-pilihan"
          >
            <p
              v-for="cabang in listPenempatan"
              :key="cabang"
              @click="openClosePilihanCabang(false, cabang)"
              style="border-top: 1px solid #ebeff2"
            >
              {{ cabang }}
              <svg
                v-if="cabang === filterData.cabang"
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M15.7142 5.71484L7.85707 13.572L4.28564 10.0006"
                  stroke="#00BA88"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </p>
          </div>
          <!-- end of box pilihan filter -->
        </div>
        <!-- end of filter cabang -->

        <!-- filter Kategori-->
        <div class="filter-pilihan">
          <div @click="openClosePilihanFilterKategori(true)" class="filter">
            <!-- tipe filter -->
            <p>Kategori :</p>
            <!-- value filter -->
            <span>{{ filterData.kategori }}</span>
            <!-- icon filter -->
            <svg
              width="10"
              height="7"
              viewBox="0 0 10 7"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M0.714294 1.35742L5.00001 5.64314L9.28572 1.35742"
                stroke="#A0A3BD"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>

          <!-- box pilihan filter -->
          <div
            style="margin-top: 2px; display: none"
            ref="boxPilihanFilterKategori"
            class="box-pilihan"
          >
            <p
              @click="openClosePilihanFilterKategori(false, kategori.nama)"
              :key="id"
              v-for="(kategori, id) in mapKategoriKlienFilter"
            >
              {{ kategori.nama }}
              <svg
                v-if="kategori.nama === filterData.kategori"
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M15.7142 5.71484L7.85707 13.572L4.28564 10.0006"
                  stroke="#00BA88"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </p>
          </div>
          <!-- end of box pilihan filter -->
        </div>
        <!-- end of filter kategori -->
      </div>
      <!-- end of list filter -->

      <!-- bagian untuk cari tambah dan download -->
      <div class="cari-tambah-download">
        <!-- box pencarian -->
        <div class="cari">
          <svg
            style="margin-right: 8px"
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M13.4286 13.4294L10.3214 10.3223M12 6.28655C12 9.44246 9.44161 12.0008 6.2857 12.0008C3.12978 12.0008 0.571411 9.44246 0.571411 6.28655C0.571411 3.13064 3.12978 0.572266 6.2857 0.572266C9.44161 0.572266 12 3.13064 12 6.28655Z"
              stroke="#A0A3BD"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>

          <input
            v-model="filterData.pencarian"
            placeholder="Cari"
            type="text"
            name=""
            id=""
          />
        </div>
        <!-- button download -->
        <button @click="downloadData" class="download">
          <svg
            width="16"
            height="16"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M13.4286 9.14375V12.0009C13.4286 12.3798 13.278 12.7431 13.0101 13.011C12.7422 13.279 12.3789 13.4295 12 13.4295H1.99998C1.6211 13.4295 1.25774 13.279 0.98983 13.011C0.721921 12.7431 0.571411 12.3798 0.571411 12.0009V9.14375M3.42855 5.57227L6.99998 9.14369M6.99998 9.14369L10.5714 5.57227M6.99998 9.14369V0.572266"
              stroke="#FCFCFC"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </button>
        <!-- open menu mobile -->
        <div class="open-menu-mobile">
          <!-- menu icon -->
          <svg
            @click="openCloseMenuMobile(true)"
            width="14"
            height="4"
            viewBox="0 0 14 4"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M6.99993 2.71422C7.39442 2.71422 7.71422 2.39442 7.71422 1.99993C7.71422 1.60544 7.39442 1.28564 6.99993 1.28564C6.60544 1.28564 6.28564 1.60544 6.28564 1.99993C6.28564 2.39442 6.60544 2.71422 6.99993 2.71422Z"
              stroke="#A0A3BD"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M11.9999 2.71422C12.3944 2.71422 12.7142 2.39442 12.7142 1.99993C12.7142 1.60544 12.3944 1.28564 11.9999 1.28564C11.6054 1.28564 11.2856 1.60544 11.2856 1.99993C11.2856 2.39442 11.6054 2.71422 11.9999 2.71422Z"
              stroke="#A0A3BD"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M1.99993 2.71422C2.39442 2.71422 2.71422 2.39442 2.71422 1.99993C2.71422 1.60544 2.39442 1.28564 1.99993 1.28564C1.60544 1.28564 1.28564 1.60544 1.28564 1.99993C1.28564 2.39442 1.60544 2.71422 1.99993 2.71422Z"
              stroke="#A0A3BD"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          <!-- end of menu icon -->

          <div
            style="display: none"
            ref="box-pilihan-menu"
            class="box-pilihan-aksi"
          >
            <!-- buka menu filter -->
            <p @click="openCloseFilterMobile(true)">
              <svg
                width="17"
                height="15"
                viewBox="0 0 17 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M16.2437 0.571289H1.04053L7.12179 7.32843V12.7141L10.1624 14.1427V7.32843L16.2437 0.571289Z"
                  stroke="#4E4B66"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              Filter
            </p>

            <!-- melakukan downlaod -->
            <p @click="downloadData">
              <svg
                width="14"
                height="14"
                viewBox="0 0 14 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M13.4287 9.14277V11.9999C13.4287 12.3788 13.2782 12.7422 13.0103 13.0101C12.7423 13.278 12.379 13.4285 12.0001 13.4285H2.0001C1.62122 13.4285 1.25786 13.278 0.989952 13.0101C0.722043 12.7422 0.571533 12.3788 0.571533 11.9999V9.14277M3.42868 5.57129L7.0001 9.14272M7.0001 9.14272L10.5715 5.57129M7.0001 9.14272V0.571289"
                  stroke="#00BA88"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              Download
            </p>
          </div>
        </div>
        <!-- end of open menu mobile -->
      </div>
    </div>
    <!-- end of bagian untuk cari tambah dan download -->

    <!-- filter mobile -->
    <div style="bottom: -100%" ref="filter-mobile" class="backdrop">
      <div class="filter-mobile">
        <div class="filter-mobile-title">
          <h5>
            Filter <br />
            klien
          </h5>
          <!-- close filter -->
          <svg
            @click="openCloseFilterMobile(false)"
            width="10"
            height="10"
            viewBox="0 0 10 10"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M9.28566 0.714355L0.714233 9.28578M0.714233 0.714355L9.28566 9.28578"
              stroke="#1A1A1A"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </div>
        <!-- input cabang -->
        <div class="keterangan input-keterangan">
          <div
            @click="openClosePilihanCabangMobile(true)"
            ref="keterangan-form"
            class="box-form email"
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M0.857178 11.5712L8.00003 15.1426L15.1429 11.5712M0.857178 7.99979L8.00003 11.5712L15.1429 7.99979M8.00003 0.856934L0.857178 4.42836L8.00003 7.99979L15.1429 4.42836L8.00003 0.856934Z"
                stroke="#A0A3BD"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>

            <div class="input-and-title">
              <span
                v-if="filterData.cabang"
                style="display: block"
                class="input-title"
                >Cabang</span
              >
              <p>
                {{ filterData.cabang ? filterData.cabang : "Cabang" }}
              </p>
            </div>
          </div>
          <!-- box pilihan cabang -->
          <div
            style="display: none"
            ref="boxPilihanCabangMobile"
            class="box-pilihan"
          >
            <p
              @click="openClosePilihanCabangMobile(false, cabang)"
              v-for="cabang in listPenempatan"
              :key="cabang"
            >
              {{ cabang }}
              <svg
                v-if="cabang === filterData.cabang"
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M15.7142 5.71484L7.85707 13.572L4.28564 10.0006"
                  stroke="#00BA88"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </p>
          </div>
          <!-- end of box pilihan cabang-->
        </div>
        <!-- end of input cabang -->
        <!-- input kategori -->
        <div class="keterangan input-keterangan">
          <div
            @click="openClosePilihanFilterKategori(true)"
            ref="keterangan-form"
            class="box-form email"
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M0.857178 11.5712L8.00003 15.1426L15.1429 11.5712M0.857178 7.99979L8.00003 11.5712L15.1429 7.99979M8.00003 0.856934L0.857178 4.42836L8.00003 7.99979L15.1429 4.42836L8.00003 0.856934Z"
                stroke="#A0A3BD"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>

            <div class="input-and-title">
              <span
                v-if="filterData.kategori"
                style="display: block"
                class="input-title"
                >Kategori</span
              >
              <p>
                {{ filterData.kategori ? filterData.kategori : "Kategori" }}
              </p>
            </div>
          </div>
          <!-- box pilihan kategori -->
          <div
            style="display: none"
            ref="boxPilihanFilterKategoriMobile"
            class="box-pilihan"
          >
            <p
              @click="openClosePilihanFilterKategori(false, kategori.nama)"
              :key="id"
              v-for="(kategori, id) in mapKategoriKlienFilter"
            >
              {{ kategori.nama }}
              <svg
                v-if="kategori.nama === filterData.kategori"
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M15.7142 5.71484L7.85707 13.572L4.28564 10.0006"
                  stroke="#00BA88"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </p>
          </div>
          <!-- end of box pilihan kategori -->
        </div>

        <!-- end of input kategori -->

        <div class="button-container">
          <button @click="openCloseFilterMobile(false)" class="yellow-button">
            Terapkan
          </button>
        </div>
      </div>
    </div>
    <!-- end of filter mobile -->

    <!-- tabel -->
    <div class="box-table">
      <table>
        <!-- judul tabel  -->
        <tr>
          <th>Kategori</th>
          <th style="width: 15%">Klien</th>
          <th>Narahubung</th>
          <th style="width: 30%">Deskripsi</th>
        </tr>
        <!-- start iterasi tabel -->
        <tr :key="index" v-for="(klien, index) in listKlienFiltered">
          <td>{{ klien.kategori }}</td>
          <td>
            <span style="color: #1d1d1d; font-weight: 700"
              >{{ klien.namaKlien }}s</span
            >
            <br />
            <div>
              <svg
                width="12"
                height="12"
                viewBox="0 0 12 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M10.5714 11.1431V10.0003C10.5714 9.39407 10.3306 8.81269 9.90197 8.38404C9.47332 7.95538 8.89194 7.71457 8.28573 7.71457H3.7143C3.10809 7.71457 2.52671 7.95538 2.09806 8.38404C1.6694 8.81269 1.42859 9.39407 1.42859 10.0003V11.1431M8.28573 3.14314C8.28573 4.4055 7.26238 5.42885 6.00002 5.42885C4.73765 5.42885 3.7143 4.4055 3.7143 3.14314C3.7143 1.88077 4.73765 0.857422 6.00002 0.857422C7.26238 0.857422 8.28573 1.88077 8.28573 3.14314Z"
                  stroke="#4E4B66"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              {{ klien.namaKaryawan }}
            </div>
          </td>
          <td>
            {{ klien.narahubung }}<br />
            {{ klien.email }}
          </td>
          <td>{{ klien.deskripsi }}</td>
        </tr>
        <!-- end iterasi tabel -->
      </table>
      <p
        v-if="!listKlienFiltered || listKlienFiltered.length === 0"
        class="empty-state-table"
      >
        Belum ada data
      </p>
    </div>
    <!-- end of tabel -->
  </div>
</template>

<script>
import XLSX from "xlsx";
import { mapState } from "vuex";
import * as soluhafire from "@/soluhafire";

export default {
  data() {
    return {
      deleteIndex: null,
      editIndex: null,
      // status modal
      modalEditIsOpen: false,
      modalBerhasilIsOpen: false,
      modalDeleteIsOpen: false,
      // filter
      filterData: {
        kategori: "Semua",
        cabang: "",
        pencarian: "",
      },
      editKlien: {
        kategori: "",
        namaKlien: "",
        email: "",
        narahubung: "",
        deskripsi: "",
      },
    };
  },

  methods: {
    openCloseMenuMobile(isOpen) {
      let box = this.$refs["box-pilihan-menu"];
      if (isOpen) box.style.display = "block";
      else box.style.display = "none";
    },

    openCloseFilterMobile(isOpen) {
      this.openCloseMenuMobile(false);
      let box = this.$refs["filter-mobile"];
      if (isOpen) box.style.bottom = "0px";
      else box.style.bottom = "-100%";
    },

    openClosePilihanFilterKategori(isOpen, value) {
      let box = this.$refs.boxPilihanFilterKategori;
      let boxMobile = this.$refs.boxPilihanFilterKategoriMobile;
      if (isOpen) {
        box.style.display = "block";
        boxMobile.style.display = "block";
      } else {
        box.style.display = "none";
        boxMobile.style.display = "none";
        this.filterData.kategori = value;
      }
    },

    openClosePilihanKategori(isOpen, value) {
      let box = this.$refs.boxPilihanKategori;
      if (isOpen) {
        box.style.display = "block";
      } else {
        box.style.display = "none";
        this.editKlien.kategori = value;
      }
    },

    openClosePilihanCabang(open, value) {
      let box = this.$refs.boxPilihanCabang;
      if (open) {
        box.style.display = "block";
      } else {
        box.style.display = "none";
        this.filterData.cabang = value;
      }
    },

    openClosePilihanCabangMobile(open, value) {
      let box = this.$refs.boxPilihanCabangMobile;
      if (open) {
        box.style.display = "block";
      } else {
        box.style.display = "none";
        this.filterData.cabang = value;
      }
    },

    // untuk tutup atau buku box pilihan
    openClosePilihanTransaksi(open, value) {
      let box = this.$refs.boxPilihanTransaksi;
      if (open) {
        box.style.display = "block";
      } else {
        this.editKlien.jenisTransaksi = value;
        box.style.display = "none";
      }
    },

    openCloseAction(isOpen, index) {
      let box = this.$refs["box-pilihan-aksi"][index];
      // tutup box action yang lain
      this.$refs["box-pilihan-aksi"].forEach((refs) => {
        refs.style.display = "none";
      });
      if (isOpen) {
        box.style.display = "block";
        this.chosenIndex = index;
      } else {
        box.style.display = "none";
      }
    },
    // end of modal open close logic

    downloadData() {
      this.openCloseMenuMobile(false);
      let dataKlien = [];
      this.listKlienFiltered.forEach((klien) => {
        dataKlien.push({
          kategori: klien.kategori,
          klien: klien.namaKlien,
          narahubung: `${klien.email} - ${klien.narahubung}`,
          namaKaryawan: klien.namaKaryawan,
        });
      });
      const data = XLSX.utils.json_to_sheet(dataKlien);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, data, "data");
      XLSX.writeFile(wb, `data_klien_${this.userData.penempatan}.xlsx`);
    },
  },

  watch: {
    "filterData.cabang": {
      handler: function (newVal) {
        soluhafire.getCeoKategoriKlien(newVal);
      },
    },
  },

  computed: {
    ...mapState([
      "userData",
      "userDocId",
      "mapKategoriKlien",
      "listKlien",
      "listPenempatan",
    ]),

    mapKategoriKlienFilter() {
      // tambah "Semua" dari list kategori yang bisa dipilih
      let mapKategoriKlienFilter = { ...this.mapKategoriKlien };
      mapKategoriKlienFilter["Semua"] = { nama: "Semua" };
      return mapKategoriKlienFilter;
    },

    listKlienFiltered() {
      // Hanya tampilkan klien
      let listKlienFiltered = this.listKlien.filter((klien) => {
        return klien.status === "klien";
      });
      let filterCabang = this.filterData.cabang;
      let filterKategori = this.filterData.kategori;

      if (filterCabang === "Semua") filterCabang = "";
      if (filterKategori === "Semua") filterKategori = "";

      let filterPencarian = this.filterData.pencarian.toLowerCase();
      // filter bedasarkan filterData
      if (listKlienFiltered) {
        return listKlienFiltered.filter((klien) => {
          let passFlag = true;

          if (filterCabang && filterCabang.length > 0) {
            passFlag = klien.cabang === filterCabang;
          }
          if (!passFlag) return false;

          if (filterKategori && filterKategori.length > 0) {
            passFlag = klien.kategori === filterKategori;
          }
          if (!passFlag) return false;

          // passFlag = namaKlienFlag || narahubungFlag || emailFlag
          if (filterPencarian && filterPencarian.length > 0) {
            passFlag = klien.namaKlien.toLowerCase().includes(filterPencarian);

            if (!passFlag) {
              passFlag = klien.narahubung
                .toLowerCase()
                .includes(filterPencarian);
            }

            if (!passFlag) {
              passFlag = klien.email.toLowerCase().includes(filterPencarian);
            }
          }
          return passFlag;
        });
      }
      return [];
    },
  },
};
</script>
